import { dom, library } from '@fortawesome/fontawesome-svg-core';

import {
  faArrowRight,
  faBars,
  faXmark,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faFilePdf,
  faFileImage,
  faLanguage,
  faGlobe,
  faPhone,
  faSearch,
  faEnvelopeOpen,
  faCommentDots,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookSquare,
  faTwitterSquare,
  faYoutubeSquare,
  faInstagramSquare,
  faLinkedin,
  faPinterestSquare,
} from '@fortawesome/free-brands-svg-icons';

import {
  awardWinner,
  carrier,
  energySaving,
  environment,
  event,
  manufactory,
  quality,
  quote,
  studiesResearch,
  team,
  value,
} from '@/icons/mds-icons';

library.add(
  awardWinner,
  carrier,
  energySaving,
  environment,
  event,
  faEnvelopeOpen,
  faArrowRight,
  faBars,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faCommentDots,
  faFacebookSquare,
  faFileImage,
  faFilePdf,
  faGlobe,
  faInstagramSquare,
  faLanguage,
  faLinkedin,
  faPhone,
  faPinterestSquare,
  faSearch,
  faTwitterSquare,
  faXmark,
  faYoutubeSquare,
  manufactory,
  quality,
  quote,
  studiesResearch,
  team,
  value,
);

dom.watch();
